// Properties file parser - parses Java .properties files
// Matches Angular gulpfile.js localization task parsing logic

/**
 * Parse a .properties file content into a key-value object
 * @param {string} content - The raw content of the .properties file
 * @returns {Object} - Parsed key-value pairs
 */
export function parsePropertiesFile(content) {
  const strings = {};

  if (!content) {
    return strings;
  }

  // Split by lines and process each line
  const lines = content.split("\n");

  lines.forEach((line) => {
    // Trim whitespace
    const trimmedLine = line.trim();

    // Skip empty lines and comments (lines starting with # or !)
    if (
      !trimmedLine ||
      trimmedLine.startsWith("#") ||
      trimmedLine.startsWith("!")
    ) {
      return;
    }

    // Find the separator (= or :)
    const separatorIndex = trimmedLine.indexOf("=");

    if (separatorIndex === -1) {
      return; // No separator found, skip this line
    }

    // Extract key and value
    const key = trimmedLine.substring(0, separatorIndex).trim();
    const value = trimmedLine.substring(separatorIndex + 1).trim();

    if (key) {
      strings[key] = value;
    }
  });

  return strings;
}

/**
 * Load and parse a properties file from a URL (for dynamic imports)
 * @param {string} url - URL to the .properties file
 * @returns {Promise<Object>} - Parsed key-value pairs
 */
export async function loadPropertiesFile(url) {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      console.warn(`Failed to load properties file: ${url}`);
      return {};
    }
    const content = await response.text();
    return parsePropertiesFile(content);
  } catch (error) {
    console.error(`Error loading properties file from ${url}:`, error);
    return {};
  }
}

const propertiesParser = {
  parsePropertiesFile,
  loadPropertiesFile,
};

export default propertiesParser;
